import { Tenant } from './tenant';

export interface TenantProvider {
    connectionDetails?: ConnectionDetailsType;
    enabled: boolean;
    id: string;
    identityTenantId: string;
    providerType: ProviderType;
    platformTenantId: string;
}

export enum ProviderType {
    Microsoft = 'Microsoft',
    Google = 'Google',
    Okta = 'Okta'
}

export interface AugmentedTenant extends Tenant {
    providerType: ProviderType | null;
}

export interface ConnectionDetailsType {
    isUpdateRequired?: boolean;
    id?: string;
}

export const PROVIDER_TYPE_ORDER = [
    ProviderType.Google,
    ProviderType.Microsoft,
    ProviderType.Okta
];
